export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-6 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              今日热播中
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              桃花视频<span className="text-primary-500">·</span>全网热门影视免费在线观看
            </h1>

            <p className="text-lg text-foreground-600 mb-3 font-heading">
              每日更新，流畅不卡顿，追剧观影首选
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              桃花视频致力于为广大观众提供<strong>91视频、久久视频、91在线视频</strong>等海量热门影视资源。平台覆盖电影、电视剧、综艺、动漫等全品类内容，支持<strong>高清全集在线观看</strong>，播放流畅不缓冲。无论是经典老片还是最新院线大片，这里都能找到。内容持续更新，确保你不错过任何一部好片，是追剧观影的首选平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">200+</div>
                <div className="text-xs text-foreground-600 mt-1">每日更新部数</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">1080P</div>
                <div className="text-xs text-foreground-600 mt-1">超清画质保障</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">20+</div>
                <div className="text-xs text-foreground-600 mt-1">全品类覆盖</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200/70"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20digital%20streaming%20platform%20interface%20displayed%20on%20a%20modern%20device%2C%20featuring%20a%20grid%20of%20colorful%20movie%20and%20TV%20show%20posters%20with%20soft%20cinematic%20lighting%2C%20warm%20coral%20and%20amber%20tones%2C%20contemporary%20flat%20design%20with%20subtle%20depth%2C%20clean%20composition%20with%20floating%20entertainment%20elements%2C%20editorial%20quality%2C%20high%20detail%2C%20professional%20photography%20style%20with%20soft%20shadows%20and%20warm%20ambient%20glow&width=960&height=720&seq=hero-visual-01&orientation=landscape"
                alt="桃花视频热门影视推荐界面"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}